module.exports = __webpack_public_path__ + "static/TW_Australia_FSG_20190515-f5a5fd63b3a2c114a0f75a0be7f30340.pdf";